import useSWRInfinite from "swr/infinite";

import { getAllBroadcastsByPackageName, getTournaments } from "_services/api/broadcast";

const fetcher = async ( { pageNo, cardId, androidPackageName, cardType } ) => {
	let sessionList = [];

	const pageSize = 10;

	if ( cardType === "tournament" ) {

		sessionList = await getTournaments ( [ cardId ], pageSize, pageNo );
		sessionList = sessionList?.tournaments.find ( item => item.id === cardId ).sessions || [];

	} else {
		sessionList = await getAllBroadcastsByPackageName ( { androidPackageName: androidPackageName, pageNo: pageNo, pageSize: 10 } );
	}

	return ( sessionList );
};

const useFetchList = ( { data } ) => {
	const { data: swrData, error, size, setSize } = useSWRInfinite (
		index => {
			return { pageNo: index + 2, cardId: data.cardId, androidPackageName: data.androidPackageName, cardType: data.cardType };
		},
		fetcher,
		{ fallbackData: [] }
	);

	// state for infinite call logic
	let __data                 = [].concat.apply ( [], swrData );
	const isLoadingInitialData = !swrData && !error;
	const isEmpty              = swrData?.[size - 1]?.length === 0;
	const isLoadingMore        = isLoadingInitialData || ( size > 0 && swrData && typeof swrData[size - 1] === "undefined" );

	const fetchMore = () => {
		setSize ( size + 1 );
	};

	return {
		fetchMore,
		__data,
		isEmpty,
		isLoadingMore
	};
};

export default useFetchList;